import React, { Component } from 'react'
import { Field } from 'redux-form'
import { Row, Col } from 'react-bootstrap'

import { renderTextField } from '../../../Forms/fieldRenderers'
import {
  required,
  getNumericValidator
} from '../../../Forms/fieldValidators'
import {
  EntityAutocomplete,
  CerealVariedadDropdown
} from '../../../Forms/SharedComponents/containers'
// import {
//  chainedNormalizer,
//  onlyNumbers,
//  nDigitsLimiter
// } from '../../../Forms/fieldNormalizers'

const numeric12 = getNumericValidator(8, 12)
const numeric2 = getNumericValidator(2)
const numeric5 = getNumericValidator(5, 5)
const numerico5 = getNumericValidator(1, 5)
const numeric8 = getNumericValidator(1, 8)

class CamposIngresoCompleto1 extends Component {
  render () {
    return (
      <div>
        <Row>
          <Col md={3} />
          <Col md={3}>
            <Field
              name='cpeSucursal'
              type='text'
              label='Nº Sucursal CPE *'
              component={renderTextField}
              autoFocus={false}
              validate={[numerico5]}
              placeholder='00001'
            />
          </Col>
          <Col md={3}>
            <Field
              name='cpeSecuencia'
              type='text'
              label='Nº de Orden CPE *'
              component={renderTextField}
              autoFocus={false}
              validate={[numeric8]}
              placeholder='00000025'
            />
          </Col>
          <Col md={3} />
          <Col md={6}>
            <EntityAutocomplete
              name='exportador'
              label='Destinatario'
              entity='exportador'
              required
              autoFocus
              placeholder='Exportador - 19999999991'
            />
          </Col>
          <Col md={6}>
            <EntityAutocomplete
              name='titular'
              required
              label='Titular de la carta *'
              entity='cargador'
              placeholder='Titular - 19999999991'
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <EntityAutocomplete
              name='remitenteComercialProductor'
              label='Remitente Comercial Productor'
              entity='cargador'
              required={false}
              placeholder='Remitente - 19999999991'
            />
          </Col>
          <Col md={6}>
            <EntityAutocomplete
              name='remitenteComercialVentaPrimaria'
              required={false}
              label='Remitente Comercial Venta Primaria'
              entity='cargador'
              placeholder='Remitente - 19999999991'
            />
          </Col>
          <Col md={6}>
            <EntityAutocomplete
              name='remitenteComercialVentaSecundaria'
              required={false}
              label='Remitente Comercial Venta Secundaria'
              entity='cargador'
              placeholder='Remitente - 19999999991'
            />
          </Col>
          <Col md={6}>
            <EntityAutocomplete
              name='corredorComprador'
              required={false}
              label='Corredor Comprador/Venta Primaria'
              entity='corredor'
              placeholder='Corredor C. - 19999999991'
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <EntityAutocomplete
              name='corredorVendedor'
              label='Corredor Vendedor/Venta Secundaria'
              entity='corredor'
              required={false}
              placeholder='Corredor V. - 19999999991'
            />
          </Col>
          <Col md={6}>
            <EntityAutocomplete
              name='transportista'
              required
              label='Transportista *'
              entity='transportista'
              placeholder='Transportista - 19999999991'
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <EntityAutocomplete
              name='chofer'
              label='Chofer *'
              entity='chofer'
              required
              placeholder='Chofer - 19999999991'
            />
          </Col>
          <Col md={6}>
            <CerealVariedadDropdown />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Field
              name='ctg'
              type='text'
              label='C.T.G. *'
              component={renderTextField}
              autoFocus={false}
              validate={[required, numeric12]}
              placeholder='10200022233'
              maxLength={12}
            />
          </Col>
          <Col md={3}>
            <Field
              name='pesoNeto'
              type='text'
              label='Kgs Neto *'
              component={renderTextField}
              autoFocus={false}
              validate={[required, numeric5]}
              // normalize={chainedNormalizer(onlyNumbers, nDigitsLimiter(5))}
              placeholder='30000'
              maxLength={5}
            />
          </Col>
          <Col md={3}>
            <Field
              name='camion'
              type='text'
              label='Camion *'
              component={renderTextField}
              autoFocus={false}
              upperCase
              validate={[required]}
              placeholder='AA111BB o AAA111'
            />
          </Col>
          <Col md={3}>
            <Field
              name='cosecha'
              type='text'
              label='Cosecha *'
              component={renderTextField}
              autoFocus={false}
              validate={[required, numeric2]}
              placeholder='11'
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ textAlign: 'right', marginTop: '8px' }}>
            <p>(*) Campo requerido obligatorio</p>
          </Col>
        </Row>
      </div>
    )
  }
}

export default CamposIngresoCompleto1
